import type { CSSProperties } from "react";

/**
 * Fixed shell for all export-related popups (bulk wizard, track wizard, format pickers).
 * Width/height stay consistent; max* caps keep the dialog inside the viewport.
 */
export const EXPORT_POPUP_SHELL_STYLE: CSSProperties = {
  width: 520,
  height: 560,
  maxWidth: "calc(100vw - 2rem)",
  maxHeight: "min(560px, 85vh)",
  boxSizing: "border-box",
  overflowX: "hidden",
  overflowY: "auto",
};
